<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="cart-overview" :busy="loadingCart">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>Checkout</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body">
                    <b-container v-bind:class="[{ busy: busy }, 'opacity-transition']" v-if="cart">
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <pb-spinner v-if="busy"/>
                        <b-row>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>BILLING ADDRESS</h4>
                                            {{user.firstName}} {{user.lastName}}
                                            <br/>
                                            {{user.externalData.company.companyName}}<br/><br/>
                                            {{user.externalData.company.street}}<br/>
                                            {{user.externalData.company.country}}-{{user.externalData.company.zipCode}}
                                            {{user.externalData.company.city}}
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-3">
                                        <b-col>
                                            <h4>DELIVERY ADDRESS</h4>
                                            <b-form-group>
                                                <b-form-radio v-model="deliveryAddressMode" :value="0" name="deliveryAddressMode">
                                                    Same as Billing Address
                                                </b-form-radio>
                                                <b-form-radio v-model="deliveryAddressMode" :value="1" name="deliveryAddressMode"
                                                              v-if="deliveryAddressOptions.length > 0">
                                                    Select from existing delivery addresses
                                                </b-form-radio>
                                                <b-form-radio v-model="deliveryAddressMode" :value="-1" name="deliveryAddressMode">
                                                    Enter new delivery address
                                                </b-form-radio>
                                            </b-form-group>

                                            <!-- Searchable Dropdown for existing addresses -->
                                            <v-select v-if="deliveryAddressMode === 1"
                                                      id="existingDeliveryAddressSelect"
                                                      name="existingDeliveryAddressSelect"
                                                      placeholder="Search and select delivery address..."
                                                      v-validate="'required'"
                                                      :class="{ 'is-invalid': errors.has('existingDeliveryAddressSelect') }"
                                                      v-model="selectedDeliveryAddress"
                                                      label="label"
                                                      :options="deliveryAddressOptions"
                                                      class="mt-2">
                                                <template v-slot:option="option">
                                                    <div>
                                                        <strong>{{ option.name }}</strong>
                                                        <div v-if="option.description" class="text-muted small">{{ option.description }}</div>
                                                        <div class="small">{{ option.street }}, {{ option.zipCode }} {{ option.city }}</div>
                                                    </div>
                                                </template>
                                            </v-select>

                                            <!-- Form for new address -->
                                            <b-form v-if="deliveryAddressMode === -1" class="mt-2">
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_recipient">Recipient:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_recipient"
                                                                name="deliveryAddress_recipient"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.recipient"
                                                                v-validate="'required'"
                                                                placeholder="Company or Personal"
                                                                :state="validateState('deliveryAddress_recipient')"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <b-form-input
                                                                id="deliveryAddress_recipient_secondary"
                                                                name="deliveryAddress_recipient_secondary"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.recipientSecondary"
                                                                placeholder="Additional Recipient Info"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_street">Street:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_street"
                                                                name="deliveryAddress_street"
                                                                type="text"
                                                                placeholder="Street and House Nr."
                                                                v-model.trim="deliveryAddress.street"
                                                                v-validate="'required'"
                                                                :state="validateState('deliveryAddress_street')"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_zip">Zip Code:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_zip"
                                                                name="deliveryAddress_zip"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.zipCode"
                                                                v-validate="'required'"
                                                                placeholder="Zip Code"
                                                                :state="validateState('deliveryAddress_zip')"
                                                        ></b-form-input>
                                                    </b-col>
                                                    <b-col>
                                                        <label for="deliveryAddress_city">City:</label>
                                                        <b-form-input
                                                                id="deliveryAddress_city"
                                                                name="deliveryAddress_city"
                                                                type="text"
                                                                v-model.trim="deliveryAddress.city"
                                                                v-validate="'required'"
                                                                placeholder="City"
                                                                :state="validateState('deliveryAddress_city')"
                                                        ></b-form-input>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="my-2">
                                                    <b-col>
                                                        <label for="deliveryAddress_country">Country:</label>
                                                        <v-select id="deliveryAddressCountrySelect"
                                                                  :clearable="false"
                                                                  name="deliveryAddressCountrySelect"
                                                                  placeholder="Please select..."
                                                                  v-validate="'required'"
                                                                  :class="{ 'is-invalid': errors.has('deliveryAddressCountrySelect') }"
                                                                  v-model="deliveryAddress.country"
                                                                  label="name"
                                                                  :options="countryList">
                                                        </v-select>
                                                    </b-col>
                                                </b-row>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>ORDER OVERVIEW</h4>
                                            <div :key="itemId" v-for="(itemId) in cart.shoppingCartItemList">
                                                <checkout-cart-item :item="itemArray[itemId]"></checkout-cart-item>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b>Total</b>
                                        </b-col>
                                        <b-col class="text-right">
                                            <b>{{total | currency($currencyFormatting[currency])}}</b>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                            <b-col lg="4">
                                <div class="bg-gray p-4">
                                    <b-row>
                                        <b-col>
                                            <h4>SEASON</h4>
                                            <v-select
                                                    id="season"
                                                    name="season"
                                                    :searchable="false"
                                                    :clearable="false"
                                                    v-model="selectedSeason"
                                                    label="description"
                                                    placeholder="Please select..."
                                                    v-validate="'required'"
                                                    v-bind:class="[{'is-invalid': errors.has('season')}]"
                                                    :options="seasonList">
                                            </v-select>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="bg-gray p-4 mt-3">
                                    <b-row>
                                        <b-col>
                                            <h4>DELIVERY DATE</h4>
                                            <b-form-datepicker

                                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                    locale="en" id="preferredDeliveryDate" name="preferredDeliveryDate" :min="new Date()"
                                                    v-validate="'required'"
                                                    v-model="preferredDeliveryDate" class="mb-2 "></b-form-datepicker>
                                            <small class="text-muted">
                                                Please select your requested delivery date here.<br/>
                                                Our Team will check, if we can meet this delivery date.<br/>
                                                But please make sure to doublecheck our CONFIRMED delivery date in our formal ORDERCONFIRMATION!
                                            </small>
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="bg-gray p-4 mt-3">
                                    <b-row>
                                        <b-col>
                                            <h4>COMMENT
                                                <small>(Optional)</small>
                                            </h4>
                                            <b-form-textarea
                                                    id="comment"
                                                    name="comment"
                                                    class="h-auto"
                                                    v-model="orderComment"
                                                    rows="4"
                                                    placeholder="Additional information..."
                                                    no-resize
                                            ></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col>
                                            <h4>INTERNAL ORDER REFERENCE
                                                <small>(Optional)</small>
                                            </h4>
                                            <b-form-input
                                                    id="reference"
                                                    name="reference"
                                                    type="text"
                                                    maxlength="30"
                                                    v-validate="'max: 30'"
                                                    v-model.trim="reference"
                                                    v-bind:class="[{'is-invalid': errors.has('reference')}]"
                                                    placeholder="Internal Order Reference"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="input-1-live-feedback">
                                                {{ errors.first('reference') }}
                                            </b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row class="mt-2">
                                    <b-col>
                                        <b-button variant="primary" class="btn-block my-2" @click="finalizeOrder">
                                            FINALIZE
                                            ORDER
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>
<script>


    import {mapActions, mapGetters, mapState} from "vuex";
    import ShoppingCartApi from "@shared/_api/shoppingCart";
    import CheckoutCartItem from "./CheckoutCartItem";
    import CartBase from "../Cart/CartBase";

    export default {
        name: 'cart-overview',
        extends: CartBase,
        props: {},
        components: {
            'checkout-cart-item': CheckoutCartItem
        },
        data() {
            return {
                preferredDeliveryDate: null,
                submitError: null,
                cartId: null,
                deliveryAddressMode: -1, // -1 = new, 0 = same as billing, 1 = select from existing
                deliveryAddress: {
                    recipient: null,
                    recipientSecondary: null,
                    street: null,
                    zipCode: null,
                    city: null,
                    country: null
                },
                busy: false,
                selectedDeliveryAddress: null,
                selectedSeason: null,
                selectedCountry: null,
                seasonList: [],
                countryList: [],
                orderComment: null,
                reference: null
            };
        },
        beforeRouteUpdate(to, from, next) {
            this.initCart(to.params.cartId);
            next();
        },
        mounted() {

        },
        created() {
            this.initCart(this.$route.params.cartId);

            this.busy = true;

            Promise.all([ShoppingCartApi.getSeasonlist(), ShoppingCartApi.getCountryList()])
                .then(([seasonList, countryList]) => {
                    // Filter seasons with valid description and add "I don't know the season" option as fallback
                    const filteredSeasonList = seasonList.filter(season => season.description && season.description.trim() !== '');
                    this.seasonList = [
                        ...filteredSeasonList,
                        { id: -1, description: "I don't know the season" }
                    ];
                    this.countryList = countryList

                }).finally(() => {

                this.busy = false;
            });
        },
        methods: {
            ...mapActions("cart", ["fetchCart"]),
            initCart: function (cartId) {
                this.cartId = Number(cartId);
            },
            updateSelectedDeliveryAddress() {
                if (this.selectedDeliveryAddress) {
                    this.deliveryAddress = {
                        recipient: this.selectedDeliveryAddress.name,
                        recipientSecondary: this.selectedDeliveryAddress.secondaryName,
                        street: this.selectedDeliveryAddress.street,
                        zipCode: this.selectedDeliveryAddress.zipCode,
                        city: this.selectedDeliveryAddress.city,
                        country: this.countryList.find(c => this.selectedDeliveryAddress.country === c.locale)
                    };
                }
            },
            finalizeOrder: function () {
                this.busy = true;

                this.submitError = null;

                // Determine delivery address type based on mode
                // COMPANY(0), DELIVERY_ADDRESS(1), NEW(-1)
                let deliveryAddressType;
                let deliveryAddressId = null;

                if (this.deliveryAddressMode === 0) {
                    deliveryAddressType = 'COMPANY';
                } else if (this.deliveryAddressMode === 1) {
                    deliveryAddressType = 'DELIVERY_ADDRESS';
                    deliveryAddressId = this.selectedDeliveryAddress ? this.selectedDeliveryAddress.id : null;
                } else {
                    deliveryAddressType = 'NEW';
                }

                let basicOrderInfo = {
                    deliveryAddressId: deliveryAddressId,
                    comment: this.orderComment,
                    deliveryAddressType: deliveryAddressType,
                    reference: this.reference,
                    orderType: 'REGULAR'
                };

                this.$validator.validate().then(valid => {
                    if (valid) {
                        let order = {
                            ...basicOrderInfo,
                            seasonId: parseInt(this.selectedSeason.id)
                        };

                        // Set address fields based on mode
                        if (this.deliveryAddressMode === 0) {
                            // COMPANY - Same as billing address
                            order.recipient = this.user.firstName + " " + this.user.lastName;
                            order.recipientSecondary = this.user.externalData.company.companyName;
                            order.street = this.user.externalData.company.street;
                            order.zipCode = this.user.externalData.company.zipCode;
                            order.city = this.user.externalData.company.city;
                            order.country = this.user.externalData.company.country;
                        } else if (this.deliveryAddressMode === 1) {
                            // DELIVERY_ADDRESS - Selected from existing
                            order.recipient = this.deliveryAddress.recipient;
                            order.recipientSecondary = this.deliveryAddress.recipientSecondary;
                            order.street = this.deliveryAddress.street;
                            order.zipCode = this.deliveryAddress.zipCode;
                            order.city = this.deliveryAddress.city;
                            order.country = this.deliveryAddress.country ? this.deliveryAddress.country.locale : null;
                        } else {
                            // NEW - Enter new address
                            order.recipient = this.deliveryAddress.recipient;
                            order.recipientSecondary = this.deliveryAddress.recipientSecondary;
                            order.street = this.deliveryAddress.street;
                            order.zipCode = this.deliveryAddress.zipCode;
                            order.city = this.deliveryAddress.city;
                            order.country = this.deliveryAddress.country.locale;
                        }

                        order.preferredDeliveryDate = this.preferredDeliveryDate;

                        return ShoppingCartApi.checkout(this.cartId, order).then(() => {
                            this.$tracker.trackEvent({
                                label: 'Checkout Cart Value',
                                meta: this.$options.filters.currency(this.total, this.$currencyFormatting[this.currency]),
                                type: 'CHECKOUT_ORDER_REGULAR'
                            });
                            return this.fetchCart();
                        }).then(() => {
                            this.$router.push({name: 'checkout-success'})
                        }).catch(() => {
                            this.submitError = "An unexpected error occured processing your order. Please contact our customer support."
                        })
                    }
                    return Promise.resolve();
                }).finally(() => {
                    this.busy = false;
                });


            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            }
        },
        computed: {
            ...mapState("cart", ['loadingCart']),
            ...mapState('account', ['user']),
            ...mapGetters('cart', ['cartArray', 'itemArray', 'cartById']),
            cart: function () {
                return this.cartById(this.cartId);
            },
            deliveryAddressOptions() {

                return this.user.deliveryAddressList ? this.user.deliveryAddressList.map((i, idx) => {
                    return {...i, label: (idx + 1) + ". " + i.name}
                }) : []
            },
        },
        watch: {
            deliveryAddressMode: function (newMode) {
                this.$validator.reset().finally(() => {
                    if (newMode === 1) {
                        // DELIVERY_ADDRESS - Select from existing
                        if (this.deliveryAddressOptions.length > 0) {
                            this.selectedDeliveryAddress = this.deliveryAddressOptions[0];
                            this.updateSelectedDeliveryAddress();
                        }
                    } else if (newMode === -1) {
                        // NEW - Enter new address
                        this.deliveryAddress = {
                            recipient: null,
                            recipientSecondary: null,
                            street: null,
                            zipCode: null,
                            city: null,
                            country: null
                        };
                        this.selectedDeliveryAddress = null;
                    } else {
                        // COMPANY - Same as billing
                        this.selectedDeliveryAddress = null;
                    }
                });
            },
            selectedDeliveryAddress: function (newAddress) {
                if (newAddress && this.deliveryAddressMode === 1) {
                    this.updateSelectedDeliveryAddress();
                }
            },
            cart: {
                handler: function (val) {
                    if(val) {
                        let orderIsOverStock = this.cart.shoppingCartItemList.find((itemId) => {
                            return this.itemArray[itemId].amount > this.itemArray[itemId].articlePrice.calculatedStock
                        });
                        this.preferredDeliveryDate = new Date();
                        if(orderIsOverStock) {
                            this.preferredDeliveryDate.setDate(this.preferredDeliveryDate.getDate() + 21 );
                        } else {
                            this.preferredDeliveryDate.setDate(this.preferredDeliveryDate.getDate() + 2 );
                        }
                    }
                },
                deep: true,
                immediate: true
            }
        },
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .cart-overview {

    }
</style>
